<script setup>
import BaseModal from "@/components/global-themed/BaseModal.vue";
import KitIcon from "@/components/approval-center/partials/kit/KitIcon.vue";
import ModalHeading from "@/components/global-themed/ui/modals/ModalHeading.vue";
import ModalSubText from "@/components/global-themed/ui/modals/ModalSubText.vue";
import ModalHeader from "@/components/global-themed/ui/modals/ModalHeader.vue";
import KitModalHeader from "@/components/global-themed/ui/modals/KitModalHeader.vue";
import ModalContentWrapper from "@/components/global-themed/ui/modals/ModalContentWrapper.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import {ref, onMounted, watch} from "vue";
import ModalHiddenCloseButtonSpacer from "@/components/global-themed/ui/modals/ModalHiddenCloseButtonSpacer.vue";
import FadeTransition from "@/components/transitions/FadeTransition.vue";

const props = defineProps({
  loading: {
    type: Boolean,
    required: true
  }
});

const emit = defineEmits(['continue']);
const showDelayedMessage = ref(false);

let timeoutId = null;
const startDelayedMessageTimer = () => {
  if (timeoutId) clearTimeout(timeoutId);
  showDelayedMessage.value = false;

  if (props.loading) {
    timeoutId = setTimeout(() => {
      if (props.loading) {
        showDelayedMessage.value = true;
      }
    }, 7000);
  }
};

watch(() => props.loading, (newValue) => {
  if (newValue) {
    startDelayedMessageTimer();

    return;
  }

  if (timeoutId) {
    clearTimeout(timeoutId);
    showDelayedMessage.value = false;
  }
});

onMounted(() => {
  startDelayedMessageTimer();
});
</script>

<template>
  <Teleport
    to=".tailwind"
  >
    <BaseModal
      modal-class="tw-w-[468px]"
      hide-close-button
      @close="emit('close')"
    >
      <ModalHiddenCloseButtonSpacer />
      <ModalContentWrapper class="tw-gap-8">
        <KitModalHeader>
          <KitIcon
            :class="[
              loading ? 'tw-w-[98px]' : 'tw-w-[88px]'
            ]"
            :state="loading ? `thinking` : `default`"
          />

          <ModalHeader>
            <ModalHeading>
              {{ loading ? 'No problem!' : 'Revised!' }}
            </ModalHeading>

            <ModalSubText>
              {{ loading ? "I'll get this sorted right away." : "Thanks! I've revised based on your feedback. Check it out!" }}
            </ModalSubText>
          </ModalHeader>
        </KitModalHeader>

        <div
          v-if="loading"
          class="tw-flex tw-flex-col tw-items-center tw-gap-6 tw-w-full"
        >
          <svg-vue
            icon="icons/loading"
            class="tw-w-12 tw-h-auto tw-text-primary-300"
          />
          <div class="tw-flex tw-flex-col tw-w-full tw-items-center">
            <span class="tw-text-neutral-900 tw-text-base">Amending</span>
            <FadeTransition>
              <span
                v-if="showDelayedMessage"
                class="tw-text-neutral tw-text-base"
              >
                (This process is taking a little longer)
              </span>
            </FadeTransition>
          </div>
        </div>

        <div class="tw-w-full">
          <DefaultButton
            class="tw-w-full"
            :disabled="loading"
            @click="emit('continue')"
          >
            Continue
          </DefaultButton>
        </div>
      </ModalContentWrapper>
    </BaseModal>
  </Teleport>
</template>
